// extracted by mini-css-extract-plugin
module.exports = {"tooltip__text-box":"Tooltip_tooltip__text-box__2SYIy"};